// Polyfill for Array.prototype.at() for older browsers
// Array.at() was added in ES2022 and is not available in older browsers
// This is needed for Sentry's LayoutShiftManager which uses this method

if (!Array.prototype.at) {
  Array.prototype.at = function(index) {
    // Convert negative index to positive
    const len = this.length;
    const relativeIndex = index >= 0 ? index : len + index;
    
    // Check if index is out of bounds
    if (relativeIndex < 0 || relativeIndex >= len) {
      return undefined;
    }
    
    return this[relativeIndex];
  };
}

